<script context="module">
    import uuid4 from '../lib/uuid_v4.js';
    import {writable} from "svelte/store";
    import Prompt from './Prompt.svelte';
    import Popup from './Popup.svelte';

    export const crumbs = writable([]);

    let dialogs = writable([]);

    let promptDetails = writable({});

    export function addCrumb(data) {
        crumbs.update(c => [...c, data]);
    }

    export function closeCrumb() {
        crumbs.update(c => c.slice(0, -1));
    }

    export function prompt(query, currentValue) {
        return new Promise((resolve, reject) => {
            let id = uuid4();
            let dialog = {
                id: id,
                component: Prompt,
                props: {
                    prompt: query,
                    response: currentValue,
                },
                onCancel: () => {
                    reject()
                    closePopup(id)
                },
                onSave: (result) => {
                    resolve(result);
                    closePopup(id);
                }
            }
            dialogs.update(d => [...d, dialog]);
        });
    }

    export function addDialog(data) {
        dialogs.update(d => [...d, data]);
    }

    export function addPopup(data) {
        data.id = uuid4()
        let popup = {
            id: data.id,
            component: Popup,
            props: data
        }

       addDialog(popup);
    }

    export function closePopup(id) {
        dialogs.update(d => d.filter((i) => i.id != id));
    }

    export function getNewId() {
        return uuid4();
    }
</script>

<script>

$: current_crumb = $crumbs[$crumbs.length - 1];
$: current_dialog = $dialogs[$dialogs.length - 1];

function cancel() {
    if (current_crumb.onCancel) {
        current_crumb.onCancel();
    }
    closeCrumb();
}

function save(evt) {
    let current_crumb = $crumbs[$crumbs.length - 1];
    if (current_crumb.onSave) {
        current_crumb.onSave(evt.detail);
    }
    closeCrumb();
}

function saveDialog(dialog, evt) {
    if (dialog.onSave) {
        dialog.onSave(evt.detail);
    }
    closePopup(dialog.id);
}

function cancelDialog(dialog) {
    if (dialog.onCancel) {
       dialog.onCancel()
    }
    closePopup(dialog.id);
}
</script>

<style>
    .hidden {
        display: none;
    }
</style>


{#each $crumbs as crumb}
    <span class:hidden={crumb != current_crumb}>
        <svelte:component this={crumb.component} {...crumb.data} on:save={save} on:close={cancel} />
    </span>
{/each}

{#each $dialogs as dialog (dialog.id)}
    <svelte:component this={dialog.component} {...dialog.props} on:save={(evt) => saveDialog(dialog, evt)} on:close={() => cancelDialog(dialog)} />
{/each}

{#if $promptDetails.prompt}
    <Prompt prompt={$promptDetails.prompt} response={$promptDetails.currentValue} on:close={$promptDetails.cancel} on:save={$promptDetails.save}></Prompt>
{/if}